import React, {
	createContext,
	useMemo,
	useState
} from 'react'
import isEmpty from 'lodash/isEmpty'
import { useTranslation } from 'react-i18next'

import { ContentBlockLoading } from 'components/ContentBlock'
import { useQuery } from 'components/graphql'

import ContentHeader from 'components/ContenHeader'

import DragAndDrop from './fragments/DragAndDrop/DragAndDrop'
import ProjectForm from './fragments/ProjectForm'
import FurnitureCreator from './fragments/FurnitureCreator'
import ProjectControls from './fragments/ProjectForm/ProjectControls'

import { StyledContainer, StyledLeftSide, StyledRightSide } from './styled'
import ProjectTree from './ProjectTree'
import TableState from './fragments/TableState'

export const RestaurantContext = createContext()

const TreeField = ({ fieldState, fieldApi, treeData, projectId, floorId, roomId, section, history, ...props }) => {
	const [t] = useTranslation()
	const getRestructedTreeData = () => [...treeData.map(projectItem => {
		const { floors, caption: projectCaption = '', ...projectData } = projectItem
		projectData.name = projectCaption
		projectData.children = floors.map(floorItem => {
			const { rooms, ...floorData } = floorItem
			floorData.name = `${t('restaurant_designer_section.strings.floor_title')} ${floorData.number}`
			floorData.children = rooms.map(roomItem => {
				const { caption: roomCaption = '', ...roomData } = roomItem
				roomData.name = roomCaption
				return roomData
			})
			return floorData
		})
		return projectData
	})]

	const restructedTreeData = getRestructedTreeData()
	return (
		<ProjectTree
			{...props}
			data={{ children: restructedTreeData, __typename: '' }}
			startAllActive={false}
			startConcealed={false}
			hideNoCRBranches={false}
			cardsInRow={1}
			height='80vh'
			isSelectable
			noQuery
			inverted
		/>
	)
}

//root
const RestaurantDesignerHandler = ({ history, section, sectionData }) => {
	const [currentProjectIds, setCurrentProjectIds] = useState({
		projectId: null,
		floorId: null,
		roomId: null
	})
	const [currentProjectData, setCurrentProjectData] = useState({
		projectData: null,
		floorData: null,
		roomData: null
	})
	const [shapeCreatorType, setShapeCreatorType] = useState('table')
	const [t] = useTranslation()

	const [activeFurnitureId, setActiveFurnitureId] = useState(null)
	const { data: restaurantData, loading } = useQuery(sectionData.query)

	const getProjectData = () => {
		let projectData = null, floorData = null, roomData = null
		if(currentProjectIds.projectId) {
			projectData = deleteValidation(restaurantData.listRestaurantProject,
				!isEmpty(restaurantData.listRestaurantProject) ? restaurantData.listRestaurantProject.find(item => item.id === currentProjectIds.projectId) : null)
			if(currentProjectIds.floorId) {
				floorData = deleteValidation(projectData ? projectData.floors : [],
					projectData ? projectData.floors.find(item => item.id === currentProjectIds.floorId) : null)
				if(currentProjectIds.roomId) {
					roomData = deleteValidation(floorData ? floorData.rooms : [],
						floorData ? floorData.rooms.find(item => item.id === currentProjectIds.roomId) : null)
				}
			}
		}
		return { projectData, floorData, roomData }
	}

	const deleteValidation = (collection, current) => {
		if(current || current === null) {
			return current
		}
		let newData = null
		if (collection[0]) {
			newData = collection[0]
		}
		return newData
	}

	useMemo(() => {
		if (!loading) {
			const newData = getProjectData(restaurantData, currentProjectIds)
			setCurrentProjectData(newData)
		}
	}, [currentProjectIds, loading, restaurantData])


	if (loading) {
		return <ContentBlockLoading style={{ height: '90vh' }} isLoading={loading}/>
	}

	return (
		<>
			<RestaurantContext.Provider value={{
				restaurantData,
				activeFurnitureId, setActiveFurnitureId,
				currentProjectIds, setCurrentProjectIds,
				currentProjectData, setCurrentProjectData,
				getProjectData,
				shapeCreatorType, setShapeCreatorType
			}}>

				<StyledContainer>
					<ProjectControls />

					<StyledLeftSide>
						<ContentHeader title={t('options_section.sub_sections.restaurant_designer')} />
						<div style={{ marginBottom: '15px' }}>
							<TreeField
								treeData={restaurantData.listRestaurantProject || []}
								section={section}
								history={history}
								isCheckable={false}
								onSelect={(item) => {
									const { id, __typename } = item
									switch(__typename) {
										case 'Project':
											setCurrentProjectIds({ projectId: id, floorId: null, roomId: null })
											break
										case 'Floor':
											setCurrentProjectIds({ projectId: item.projectId, floorId: id, roomId: null })
											break
										case 'Room':
											setCurrentProjectIds({ projectId: item.projectId, floorId: item.floorId, roomId: id })
											break
										default:
											return
									}
								}}
								{...currentProjectIds}
								defaultSelected={{ id: currentProjectIds.projectId, __typename: 'Project' }}
							/>

						</div>
						{(currentProjectIds.roomId) && <FurnitureCreator {...sectionData} />}

					</StyledLeftSide>

					{(currentProjectData.projectData) && (
						<StyledRightSide>
							<ProjectForm {...sectionData} />
							{(currentProjectIds.roomId) && (
								<>
									<DragAndDrop {...sectionData}/>
									{
										process.env.REACT_APP_STAGE === 'prod' ? (
											<TableState />
										) : null
									}
								</>
							)}

						</StyledRightSide>
					)}
				</StyledContainer>
			</RestaurantContext.Provider>
		</>

	)
}


export default RestaurantDesignerHandler
